// extracted by mini-css-extract-plugin
export default {"form":"classes_form__rdN78","form-container":"classes_form-container__Dry6K","button-container":"classes_button-container__haAC0"};